import React, { useEffect, useState } from "react"
import { useTranslation } from 'react-i18next'
import { Dropdown, Modal } from 'react-bootstrap'
import Select from 'react-select'

import { httpOk, GET, POST, PUT, DELETE } from 'helpers/api'
import { formatMoney } from 'helpers/helpers'

/**
 * ЧИҚИМ ГУРУҲЛАРИ — sozlamalar (2026-08-06)
 *
 * Har tenant o'z guruhlarini boshqaradi: qo'shadi, nomini va tartibini
 * o'zgartiradi, keraksizni yashiradi.
 *
 * Dastlab ro'yxat kodda qat'iy edi; foydalanuvchi «yangi nom qo'sha olay»
 * dedi va bu to'g'ri — 8 ta tenantning biznesi har xil.
 *
 * ⚠️ «Фойдага таъсири» — SUKUT qiymat. Modda shu guruhga qo'shilganda o'sha
 *    moddaga ko'chiriladi. Keyin bu yerda o'zgartirilsa MAVJUD moddalarga
 *    TEGMAYDI — aks holda bitta selekt o'tgan oylarning hisobotini jimgina
 *    qayta hisoblab yuborardi.
 */
function Index() {
	const { t } = useTranslation()

	const effects = [
		{ 'id': 'expense', 'name': t('pl_effect_expense') },
		{ 'id': 'neutral', 'name': t('pl_effect_neutral') },
		{ 'id': 'income', 'name': t('pl_effect_income') },
	]

	const [data, setData] = useState([])
	const [showModal, setShowModal] = useState(false)
	const [selectedItem, setSelectedItem] = useState({ 'default_effect': 'expense' })
	const [deleteModal, setDeleteModal] = useState({ show: false, item: null })

	const PALETTE = [
		{ background: '#e8effc', color: '#2456a6' },
		{ background: '#f0eafc', color: '#5b34a8' },
		{ background: '#e4f4f4', color: '#12706e' },
		{ background: '#fdefe3', color: '#a35a12' },
		{ background: '#fdeaea', color: '#a32d2d' },
		{ background: '#e8f5ec', color: '#1c7340' },
		{ background: '#eef0f3', color: '#5d6674' },
		{ background: '#f2f3f5', color: '#7b8494' },
	]
	const styleOf = (id) => PALETTE[id % PALETTE.length]

	async function getData() {
		const response = await GET('/payment-purpose-groups', {}, { loader: true })
		if (httpOk(response)) setData(response.data)
	}

	async function createUpdate(e) {
		e.preventDefault()
		var response
		if (selectedItem.id) {
			response = await PUT('/payment-purpose-groups', selectedItem, { loader: true })
		} else {
			response = await POST('/payment-purpose-groups', selectedItem, { loader: true })
		}
		if (httpOk(response)) {
			getData()
			setShowModal(false)
			setSelectedItem({ 'default_effect': 'expense' })
		}
	}

	async function confirmDelete() {
		const response = await DELETE(`/payment-purpose-groups/${deleteModal.item.id}`, {}, { loader: true })
		if (httpOk(response)) {
			setDeleteModal({ show: false, item: null })
			getData()
		}
	}

	function toggleModal(bool = false, item = { 'default_effect': 'expense' }) {
		setSelectedItem(item)
		setShowModal(bool)
	}

	/** Tartibni bir pog'ona surish — raqam yozdirmasdan */
	async function move(item, dir) {
		const idx = data.findIndex(x => x.id === item.id)
		const other = data[idx + dir]
		if (!other) return
		// Ikkalasining tartibini almashtiramiz
		await PUT('/payment-purpose-groups',
			{ ...item, sort_order: other.sort_order }, { loader: false })
		await PUT('/payment-purpose-groups',
			{ ...other, sort_order: item.sort_order }, { loader: false })
		getData()
	}

	useEffect(() => { getData() }, []) // eslint-disable-line react-hooks/exhaustive-deps

	return (
		<>
			<div className="page-header d-flex justify-content-between">
				<h4 className="vertical-center h-100">
					{t('pl_groups')} [{data.length}]
				</h4>
				<div className="vertical-center">
					<button className="btn btn-primary btn-wide" onClick={() => toggleModal(true)}>
						{t('create')}
					</button>
				</div>
			</div>

			<div className="card">
				<div className="card-body">
					<div className="alert alert-light border mb-3" style={{ fontSize: '13px' }}>
						{t('pl_groups_hint')}
					</div>

					<div className="table-responsive">
						<table className="table table-bordered mb-0">
							<thead>
								<tr>
									<th style={{ minWidth: '33px' }} className="text-center">#</th>
									<th style={{ width: '35%' }}>{t('name2')}</th>
									<th style={{ width: '25%' }}>{t('pl_effect')}</th>
									<th style={{ width: '15%' }} className="text-center">{t('pl_purposes_count')}</th>
									{/* ⚠️ `order` kaliti allaqachon «Буюртма» ma'nosida ishlatiladi —
									    shuning uchun alohida `pl_order` kaliti */}
									<th style={{ width: '15%' }} className="text-center">{t('pl_order')}</th>
									<th style={{ minWidth: '33px' }}></th>
								</tr>
							</thead>
							<tbody>
								{data.length === 0 ? (
									<tr><td colSpan="6" className="text-center text-muted py-4">{t('list_empty')}</td></tr>
								) : data.map((item, index) => (
									<tr key={item.id}>
										<td className="text-center">{index + 1}</td>
										<td>
											<span className="badge" style={styleOf(item.id)}>{item.name}</span>
										</td>
										<td>
											{item.default_effect === 'expense' &&
												<span className="text-danger">{t('pl_effect_expense')}</span>}
											{item.default_effect === 'neutral' &&
												<span className="text-muted">{t('pl_effect_neutral')}</span>}
											{item.default_effect === 'income' &&
												<span className="text-success">{t('pl_effect_income')}</span>}
										</td>
										<td className="text-center">
											{Number(item.purposes_count) > 0
												? formatMoney(item.purposes_count)
												: <span className="text-muted">0</span>}
										</td>
										<td className="text-center text-nowrap">
											<i className="uil-arrow-up cursor me-2"
												style={{ opacity: index === 0 ? .25 : 1 }}
												onClick={() => index > 0 && move(item, -1)} />
											<i className="uil-arrow-down cursor"
												style={{ opacity: index === data.length - 1 ? .25 : 1 }}
												onClick={() => index < data.length - 1 && move(item, 1)} />
										</td>
										<td>
											<div className="table-dropdown">
												<Dropdown id={`dropdown-${index}`}>
													<Dropdown.Toggle variant="outline-primary">
														<i className="uil uil-ellipsis-v"></i>
													</Dropdown.Toggle>
													<Dropdown.Menu>
														<div className="table-dropdown-item"
															onClick={() => toggleModal(true, item)}>
															<i className="uil-edit-alt"></i>
															{t('edit')}
														</div>
														{/* Moddasi bor guruh o'chirilmaydi — backend ham to'sadi */}
														<div className="table-dropdown-item text-danger"
															onClick={() => setDeleteModal({ show: true, item })}>
															<i className="uil-trash-alt"></i>
															{t('delete')}
														</div>
													</Dropdown.Menu>
												</Dropdown>
											</div>
										</td>
									</tr>
								))}
							</tbody>
						</table>
					</div>
				</div>
			</div>

			{/* YARATISH / TAHRIRLASH */}
			<Modal show={showModal} animation={false} centered backdrop="static"
				onHide={() => toggleModal(false)}>
				<Modal.Header closeButton>
					<Modal.Title>{!selectedItem.id ? t('create') : t('edit')}</Modal.Title>
				</Modal.Header>
				<Modal.Body>
					<form onSubmit={(e) => createUpdate(e)} autoComplete="off">
						<div className="form-group">
							<label>{t('name2')}</label>
							<input type="text" className="form-control" autoFocus
								value={selectedItem.name ?? ''}
								onChange={(e) => setSelectedItem({ ...selectedItem, 'name': e.target.value })} />
						</div>
						<div className="form-group">
							<label>{t('pl_effect')}</label>
							<Select
								options={effects}
								value={effects.find(o => o.id === selectedItem.default_effect) || null}
								onChange={(option) => setSelectedItem({ ...selectedItem, 'default_effect': option?.id })}
								placeholder=""
								noOptionsMessage={() => t('list_empty')}
								getOptionLabel={(option) => option.name}
								getOptionValue={(option) => option.id}
							/>
							<div className="text-muted mt-1" style={{ fontSize: '12px' }}>
								{t('pl_effect_default_hint')}
							</div>
						</div>
						<div className="d-flex gap-2 justify-content-end">
							<button type="button" className="btn btn-outline-warning btn-wide"
								onClick={() => toggleModal(false)}>{t('cancel')}</button>
							<button type="submit" className="btn btn-primary btn-wide"
								disabled={!selectedItem.name}>{t('save')}</button>
						</div>
					</form>
				</Modal.Body>
			</Modal>

			{/* O'CHIRISH */}
			<Modal show={deleteModal.show} animation={false} centered
				onHide={() => setDeleteModal({ show: false, item: null })}>
				<Modal.Header closeButton><Modal.Title>{t('delete')}</Modal.Title></Modal.Header>
				<Modal.Body>
					<p>{deleteModal.item?.name}</p>
					<div className="d-flex gap-2 justify-content-end">
						<button className="btn btn-outline-warning btn-wide"
							onClick={() => setDeleteModal({ show: false, item: null })}>{t('cancel')}</button>
						<button className="btn btn-danger btn-wide" onClick={confirmDelete}>{t('delete')}</button>
					</div>
				</Modal.Body>
			</Modal>
		</>
	)
}

export default Index
